<template>
  <div class="container mb-5">
    <h1>
      <b-icon icon="people-fill"></b-icon> Your Advisor

      <div class="float-right" style="margin-top: -62px;">
        <b-button
          v-b-modal.modal-lg
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >
      </div>
    </h1>

  <div>
    <div class="text-center" v-if="isLoading ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    <div class="row" v-if="!isLoading">

                  <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="empty">
                       No data found about advisor for you.
                  </b-card>
      <div v-else class="col-md-8 col-sm-12 mt-4" v-for="(item, index) of studentAdvisor" :key="index">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <div class="panal mt-20">
              <div class="panal-body img-responsive">
                <img
                  class="img-fluid"
                  src="../../../assets/user-icon-image-7.jpg"
                />

                <div class="profile-data">
                  <h3>
                    <span> {{item.AcademicStaffName}} </span>
                  </h3>

                  <div> {{item.AdvisorTypeName}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-sm-12">
            <div class="panal mt-20">
              <div class="panal-body">
                <div class="row">
                  <div class="col-md-4 mb-4"><strong>Type : </strong></div>
                  <div class="col-md-8 text-warning">
                    <strong> {{item.AdvisorTypeName}} </strong>
                  </div>
                   <div class="col-md-4 mb-4"><strong>Name : </strong></div>
                  <div class="col-md-8 text-warning">
                    <strong> {{item.AcademicStaffName}} </strong>
                  </div>

                  <div class="col-md-4 mb-4"><strong> Days : </strong></div>
                  <div class="col-md-8 text-warning">
                    <strong> {{item.academicDays ? item.academicDays : "---"}} </strong>
                  </div>
                  <!-- <div class="col-md-4 mb-4"><strong> Time : </strong></div>
                  <div class="col-md-8 text-warning">
                    <strong> 9AM : 2PM </strong>
                  </div> -->
                  <div class="col-md-4 mb-4"><strong> Group : </strong></div>
                  <div class="col-md-8 text-warning">
                    <strong> {{item.GroupName}} </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
</div>
    <div class="text-right col-md-12 float-right mt-3">
      <button class="btn btn-primary mr-2" @click="adviser">
        Back to Adviser
      </button>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import StudentAdvisor from "../../../services/academic/StudentAdvicessServices";

export default {
  name: "Co-advisor",
  data() {
    return {
      studentAdvisor: [],
      isLoading: true,
       empty : true, 
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    //this.currenUser.StudentID
    StudentAdvisor.Student_Advisor_Data(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.studentAdvisor = Response.data;
        this.empty =false;
          if(this.studentAdvisor == 0)
              {
                this.empty = true;
                return true;
              }
         // eslint-disable-next-line no-console
         console.log(this.studentAdvisor)
      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status)
      this.empty =true;
      this.isLoading =false;
        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    );
  },
  methods: {
    adviser() {
      this.$router.push("/Adviser");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.img-profile {
  border-radius: 50%;
  width: 180px;
  border: 2px solid #285475;
}

.img-user {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  border: 2px dotted #ff8600;
  background: #f2f2f2;
  text-align: center;
  vertical-align: middle;
  padding: 21px;
  float: left;
  margin: 10px;
  font-size: 34px;
}

.active2 {
  background: #285475 !important;
  color: #fff;
}
.title {
  color: #285475;
  font-weight: 700;
  text-align: left;
}
.changeImg {
  margin-top: -40px;
  position: absolute;
  left: 180px;
}
.changeImg a {
  color: #ff8600;
}
.profileData {
  border: 1px dotted #646464;
  color: #285475;
  padding: 3px 10px;
  font-weight: 700;
}

.profileData2 {
  border: 1px dotted #646464;
  color: #ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix {
  clear: both;
  display: table;
}
.line1 {
  border-top: 1px dotted #285475;
  border-bottom: 1px dotted #285475;
  height: 10px;

  float: left;
  margin: 57px 20px;
}

@media screen and (max-width: 1024px) {
  .line1 {
    display: none;
  }
}

@media screen and (max-width: 1180px) and (min-width: 750px) {
  .img-profile {
    border-radius: 50%;
    width: 100px;
    border: 2px solid #285475;
  }
}

.profile-data {
  position: absolute;
  bottom: 0;
  left: 15px;
  right: 15px;
  overflow: hidden;
  min-height: 0;
  max-height: 50%;
  padding: 10px;
  background: #406383;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0, rgba(64, 99, 131, 0.8)),
    color-stop(10%, rgba(49, 86, 120, 0.9)),
    color-stop(90%, rgba(49, 86, 120, 0.9)),
    color-stop(100%, rgba(64, 99, 131, 0.9))
  );
  background: linear-gradient(
    180deg,
    rgba(64, 99, 131, 0.8) 0,
    rgba(49, 86, 120, 0.9) 10%,
    rgba(49, 86, 120, 0.9) 90%,
    rgba(64, 99, 131, 0.9)
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr= #406383,endColorstr= #315678,GradientType=0);
  color: #fff;
  text-align: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  transition: all 0.5s ease-in-out;
}

.profile-data h3 {
  width: 100%;
  margin: 0;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  font-size: 16px;
  line-height: 1.1em;
}
.text-warning {
  color: #ff8600;
}
</style>
